import * as React from 'react';
import HierarchicalDevicePicker from './HierarchicalDevicePicker';
import { AlgoliaDevicePicker } from './AlgoliaDevicePicker';
import { DevicePickerProps, View } from './types';
import {
   useDevicePickerContext,
   withDevicePickerContext,
} from './DevicePickerContext';
export { View };

export const DevicePicker = withDevicePickerContext(DevicePickerComponent);

export function DevicePickerComponent(props: DevicePickerProps) {
   const algoliaConfig = props.algoliaConfig;
   const { state, query, loaded, setState, setQuery, setCategory } =
      useDevicePickerContext();

   const handleKeyDown = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') {
         props.onCancel();
      }
   };

   React.useEffect(() => {
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
   }, []);

   if (
      !loaded ||
      algoliaConfig === undefined ||
      state === 'category' ||
      !query
   ) {
      return (
         <HierarchicalDevicePicker
            onSearch={(value) => {
               setState('search');
               setQuery(value);
            }}
            {...props}
         />
      );
   }

   return (
      <AlgoliaDevicePicker
         onSelectCategory={(category) => {
            setState('category');
            setCategory(category);
            setQuery(category);
         }}
         algoliaConfig={algoliaConfig}
         {...props}
      />
   );
}
